/** Quy đổi đơn giá trong hộp Thêm sản phẩm của PI (yêu cầu v1.8 mục 6.4, 11/10/2026). */
export const fxConvertEn = {
  toggle: "Convert product unit price",
  toggleHint: "Off: prices keep their own currency; a price in another currency stays blank for you to enter in {{currency}}. On: convert with the rate set in Settings, shown before it is applied.",
  source: "Source currency",
  sourcePrice: "Original unit price",
  target: "Target currency",
  rate: "Rate applied",
  result: "Converted unit price",
  exact: "unrounded {{value}}",
  same: "Same currency — the price is kept unchanged.",
  missingRate: "No rate for {{a}} ↔ {{b}}. Set it in Settings → Currencies by company & price conversion rates before converting.",
  openSettings: "Open Settings",
  targetMismatch: "The target must be this PI's currency ({{currency}}).",
  invalidPrice: "Enter the original unit price as a plain number (up to 4 decimals).",
  loadingPrice: "Loading the customer's price…",
  stopped: "{{code}}: fix the conversion before adding.",
  lineNote: "converted from {{note}}",
  lineNoteTitle: "This unit price was converted from another currency with the rate shown. Editing the price by hand removes this note.",
  basisColumn: "Currency conversion",
  precision: "Stored at 4 decimals, the system's unit-price precision.",
  waitPrice: "Wait until the customer's prices finish loading, then add.",
  priceFailed: "The customer's own price could not be loaded — this is the catalogue price. Check it before adding.",
  errSameCurrency: "Line {{line}}: the source currency is already the PI currency — no conversion is needed. Enter the price directly.",
  errRateMissing: "Line {{line}}: no exchange rate is set for this currency pair. Set it in Settings, or enter the price directly.",
  errRateChanged: "Line {{line}}: the exchange rate in Settings changed after this price was converted. Convert it again, or enter the price directly.",
  errMismatch: "Line {{line}}: the unit price no longer matches the converted price. Convert it again, or enter the price directly.",
};

export const fxConvertVi: typeof fxConvertEn = {
  toggle: "Quy đổi đơn giá sản phẩm",
  toggleHint: "Tắt: giá giữ nguyên tiền tệ của nó; giá ở tiền tệ khác để trống để anh/chị nhập bằng {{currency}}. Bật: quy đổi theo tỷ giá trong Cài đặt, xem trước rồi mới áp.",
  source: "Tiền tệ gốc",
  sourcePrice: "Đơn giá gốc",
  target: "Tiền tệ đích",
  rate: "Tỷ giá áp dụng",
  result: "Đơn giá sau quy đổi",
  exact: "chưa làm tròn {{value}}",
  same: "Cùng tiền tệ — giữ nguyên giá.",
  missingRate: "Chưa có tỷ giá {{a}} ↔ {{b}}. Đặt tỷ giá ở Cài đặt → Tiền tệ theo công ty & tỷ giá quy đổi trước khi quy đổi.",
  openSettings: "Mở Cài đặt",
  targetMismatch: "Tiền tệ đích phải là tiền tệ của PI này ({{currency}}).",
  invalidPrice: "Nhập đơn giá gốc là số (tối đa 4 chữ số lẻ).",
  loadingPrice: "Đang tải giá của khách…",
  stopped: "{{code}}: sửa phần quy đổi trước khi thêm.",
  lineNote: "quy đổi từ {{note}}",
  lineNoteTitle: "Đơn giá này được quy đổi từ tiền tệ khác theo tỷ giá ghi kèm. Sửa tay giá thì ghi chú này mất.",
  basisColumn: "Quy đổi tiền tệ",
  precision: "Lưu 4 chữ số lẻ — độ chính xác đơn giá của hệ.",
  waitPrice: "Chờ giá riêng của khách tải xong rồi hãy thêm.",
  priceFailed: "Không tải được giá riêng của khách — đây là giá danh mục. Kiểm lại trước khi thêm.",
  errSameCurrency: "Dòng {{line}}: tiền gốc đã là tiền của PI — không cần quy đổi. Nhập thẳng đơn giá.",
  errRateMissing: "Dòng {{line}}: chưa đặt tỷ giá cho cặp tiền này. Đặt trong Cài đặt, hoặc nhập thẳng đơn giá.",
  errRateChanged: "Dòng {{line}}: tỷ giá trong Cài đặt đã đổi sau khi quy đổi giá này. Quy đổi lại, hoặc nhập thẳng đơn giá.",
  errMismatch: "Dòng {{line}}: đơn giá không còn khớp giá đã quy đổi. Quy đổi lại, hoặc nhập thẳng đơn giá.",
};

export const fxConvertZh: typeof fxConvertEn = {
  toggle: "换算产品单价",
  toggleHint: "未勾选：价格保留原币种；其他币种的价格留空，请以 {{currency}} 输入。勾选：按设置中的汇率换算，先预览再应用。",
  source: "原币种",
  sourcePrice: "原单价",
  target: "目标币种",
  rate: "所用汇率",
  result: "换算后单价",
  exact: "未四舍五入 {{value}}",
  same: "币种相同——价格保持不变。",
  missingRate: "尚未设置 {{a}} ↔ {{b}} 汇率。请先在 设置 → 各公司币种与价格换算汇率 中设置。",
  openSettings: "打开设置",
  targetMismatch: "目标币种必须是本 PI 的币种（{{currency}}）。",
  invalidPrice: "请以数字输入原单价（最多 4 位小数）。",
  loadingPrice: "正在载入客户价格…",
  stopped: "{{code}}：请先修正换算再加入。",
  lineNote: "换算自 {{note}}",
  lineNoteTitle: "此单价按所示汇率由其他币种换算而来。手动修改价格后此备注会消失。",
  basisColumn: "币种换算",
  precision: "按系统单价精度保存 4 位小数。",
  waitPrice: "请等客户专属价格载入完成后再加入。",
  priceFailed: "无法载入客户专属价格，此为目录价格。加入前请核对。",
  errSameCurrency: "第 {{line}} 行：原币已是 PI 币种，无需换算。请直接输入单价。",
  errRateMissing: "第 {{line}} 行：此货币对尚未设置汇率。请在设置中设置，或直接输入单价。",
  errRateChanged: "第 {{line}} 行：此价格换算后，设置中的汇率已更改。请重新换算，或直接输入单价。",
  errMismatch: "第 {{line}} 行：单价与换算结果不再一致。请重新换算，或直接输入单价。",
};
